import { gfParseFieldValuesType } from './gf-parse-fieldvalues-type.helpers'

export const gfTransformFieldValuesToPayload = fieldValues => {
  const transformed = {}
  for (const [key, value] of Object.entries(fieldValues)) {
    const newKey = key.replace('.', '_')
    const trueValue = gfParseFieldValuesType(value)
    transformed[`input_${newKey}`] = trueValue
  }

  // Captcha cannot have input in front of it
  if (transformed['input_g-recaptcha-response']) {
    transformed['g-recaptcha-response'] = transformed['input_g-recaptcha-response']
    delete transformed['input_g-recaptcha-response']
  }
  return transformed
}
